export * from './constants';
export * from './shared.module';

/**
 * This folder contains shared components, directives, pipes and utilities that are used across different parts of the application.
 * It promotes code reuse and maintains consistency in the user interface and functionality.
 */
